import React from "react";
import { useTranslation } from "react-i18next";

import career from "../assets/figma/career.svg";
import icon1 from "../assets/figma/location.svg";
import icon33 from "../assets/figma/quote.svg";


function ContactUs() {
  const { t } = useTranslation();

  const mapsUrl =
    "https://www.google.com/maps/search/?api=1&query=Corso+Giuseppe+Zanardelli+38+Brescia+BS+Italy";

  return (
    <main id="contactUs" className="contact-page">
      <section className="contact-hero">
        <div>
          <h1>{t("main.contactUsPage.heroTitle")}</h1>
          <span />
        </div>
      </section>

      <section className="contact-info-section">
        <div className="contact-info-grid">
          <article className="contact-info-item">
            <img src={icon33} alt={t("main.contactUsPage.requestQuote")} />

            <div className="contact-info-content">
              <h3>{t("main.contactUsPage.requestQuote")}</h3>

              <div className="contact-links">
                <a className="contact-mail" href="mailto:info@rigsave.com">
                  info@rigsave.com
                </a>

                <a className="contact-phone" href="tel:+393392246507">
                  (+39) 3392246507
                </a>
              </div>
            </div>
          </article>

          <div className="contact-career">
            <img src={career} alt="" />
            <div><h3>{t("main.contactUsPage.careerTitle")}</h3>
              <a href="mailto:info@rigsave.com?subject=Curriculum%20Vitae">{t("main.contactUsPage.careerText")}</a>
            </div>
          </div>

          <div className="contact-divider" />

          <article className="contact-info-item">
            <img src={icon1} alt={t("main.contactUsPage.visitUsTitle")} />

            <div className="contact-info-content">
              <h3>{t("main.contactUsPage.visitUsTitle")}</h3>

              <strong>{t("main.contactUsPage.appointmentOnly")}</strong>

              <a
                className="contact-address"
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                C.so Giuseppe Zanardelli
                <br />
                38, Brescia (BS), Italy
              </a>
            </div>
          </article>
        </div>
      </section>

    </main>
  );
}

export default ContactUs;

